import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDelete, doDownload, doPostFiles, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:9004/api'

//PerProject
export const downloadExtentionTimePerProjectReport = (req) => {
  const url = `${API_ROOT}/contract/download/extention-time-perproject/report`
  return doPostDownload(url, req)
}

export const searchExtentionTimePerProjectPage = (req) => {
  const url = `${API_ROOT}/contract/get/extention-time-perproject/page`
  return doPost(url, req)
}

//PerPeriod
export const downloadExtentionTimePerPeriodReport = (req) => {
  const url = `${API_ROOT}/contract/download/extention-time-perperiod/report`
  return doPostDownload(url, req)
}

export const searchExtentionTimePerPeriodPage = (req) => {
  const url = `${API_ROOT}/contract/get/extention-time-perperiod/page`
  return doPost(url, req)
}

//Overview
export const downloadExtentionTimeOverviewReport = (req) => {
  const url = `${API_ROOT}/contract/download/extention-time-overview/report`
  return doPostDownload(url, req)
}

export const searchExtentionTimeOverviewPage = (req) => {
  const url = `${API_ROOT}/contract/get/extention-time-overview/page`
  return doPost(url, req)
}
